import * as React from "react"
const TelephoneBoot = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    className="icon"
    transform="rotate(-45)"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path fill="#D1D3D3" d="M475.7 614.5H611v302.4H475.7z" />
    <path d="M475.7 614.5H611v67.7H475.7z" />
    <path
      fill="#0071CE"
      d="M747.9 88.5c0-15.9-13-29-29-29H367.7c-15.9 0-29 13-29 29v521.2c0 15.9 13 29 29 29h351.2c15.9 0 29-13 29-29V88.5z"
    />
    <path
      fill="#D1D3D3"
      d="M429.6 576.8c-15.9 0-29-13-29-29V150.3c0-15.9 13-29 29-29h227.6c15.9 0 29 13 29 29v397.5c0 15.9-13 29-29 29H429.6z"
    />
    <path d="M657.1 121.4H429.6c-15.9 0-29 13-29 29v31.1c0-15.9 13-29 29-29h227.6c15.9 0 29 13 29 29v-31.1c-.1-16-13.2-29-29.1-29z" />
    <path
      fill="#333E48"
      d="M418.7 776c-76.7 0-139.1-62.4-139.1-139.1V342.7c0-32.6 26.5-59.1 59.1-59.1v29c-16.6 0-30.2 13.5-30.2 30.1v294.2c0 60.7 49.4 110.1 110.1 110.1s110.1-49.4 110.1-110.1v-90.5h29v90.5c.1 76.7-62.3 139.1-139 139.1z"
    />
    <path d="M528.8 546.4v31.2c4.7.8 9.6 1.2 14.5 1.2s9.8-.4 14.5-1.2v-31.2h-29zM313.6 289.1V326c5.4-8.1 14.6-13.5 25.1-13.5v-29c-8.9 0-17.4 2-25.1 5.6z" />
    <path
      fill="#333E48"
      d="M648.7 947.9c0 6.4-5.2 11.6-11.6 11.6H449.6c-6.4 0-11.6-5.2-11.6-11.6V908c0-6.4 5.2-11.6 11.6-11.6h187.5c6.4 0 11.6 5.2 11.6 11.6v39.9z"
    />
    <path d="M501.49999999999994 847.8a13.8 13.8 0 1 0 27.6 0 13.8 13.8 0 1 0-27.6 0ZM557.6 847.8a13.8 13.8 0 1 0 27.6 0 13.8 13.8 0 1 0-27.6 0Z" />
    <path
      fill="#333E48"
      d="M578.8 430.8V293.6c19.3-11.9 32.2-33.3 32.2-57.6 0-37.3-30.3-67.6-67.6-67.6s-67.6 30.3-67.6 67.6c0 24.4 12.9 45.7 32.2 57.6v137.2c-19.3 11.9-32.2 33.3-32.2 57.6 0 37.3 30.3 67.6 67.6 67.6s67.6-30.3 67.6-67.6c0-24.4-12.9-45.7-32.2-57.6z"
    />
  </svg>
)
export default TelephoneBoot
